import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const ListViewIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path d="M7 5L17 5" stroke="currentColor" />
      <path d="M4 12L20 12" stroke="currentColor" />
      <path d="M7 19L17 19" stroke="currentColor" />
    </SvgIcon>
  )
}
